import React from 'react';
import ErrorImage from '../../../../assets/images/generalErrorImage.svg';

export const EmptyTableState = () => (
  <div style={{ margin: 4 }}>
    <img src={ErrorImage} alt="No data found" />
    <h6>No data found</h6>
  </div>
);
